import Modal from '../../_ui/modal'
import { useFeedModalStore } from '../store/feed-modal-store'
import Feed from './feed'

const FeedModal = () => {
  const open = useFeedModalStore(s => s.open)
  const handleClose = useFeedModalStore(s => s.handleClose)
  const selected = useFeedModalStore(s => s.selected)
  return (
    <Modal
      fitContent
      open={open}
      onClose={handleClose}
      disableOutsideClick
      header={{ text: 'Detail Feed' }}
      render={() => (
        <div
          style={{
            minWidth: '20rem',
            maxWidth: '20rem',
          }}
        >
          <Feed item={selected} />
        </div>
      )}
    />
  )
}

export default FeedModal
